module.exports = __webpack_public_path__ + "public/files/img/whats-1.db2867c2.png";